import { getFormattedDate } from '@/utils/index';
import { getLoginUserDetail } from '@/api/OrganApi';
import * as md5Module from 'js-md5';
let isRefreshing = false;
let pendingQueue = []; // 改为等待 token 的 promise 队列
export const ensureToken = async () => {
    // 1. 先读本地
    let token = sessionStorage.getItem('flowToken');
    // console.log('ccflow token:', token)
    if (token)
        return token;
    // 2. 无 token，需要刷新
    if (isRefreshing) {
        // 已在刷新中：排队等结果
        return new Promise((resolve, reject) => {
            pendingQueue.push({
                resolve,
                reject,
            });
        });
    }
    isRefreshing = true;
    try {
        const loginRes = await getNewToken(); // 沿用之前的 getNewToken
        // console.log('loginRes', loginRes)
        token = loginRes.token;
        sessionStorage.setItem('flowToken', token);
        // 成功：清空排队，全部返回同一个 token
        while (pendingQueue.length) {
            const { resolve } = pendingQueue.shift();
            resolve(token);
        }
        return token;
    }
    catch (err) {
        // 失败：清空排队并统一抛错
        while (pendingQueue.length) {
            const { reject } = pendingQueue.shift();
            reject(err);
        }
        throw err;
    }
    finally {
        isRefreshing = false;
        pendingQueue = [];
    }
};
const getNewToken = async () => {
    try {
        const userId = JSON.parse(sessionStorage.getItem('user')).id;
        const userName = JSON.parse(sessionStorage.getItem('user')).userName;
        const belongId = sessionStorage.getItem('belongId');
        if (!userId || !belongId)
            throw new Error('未获取到当前登录信息');
        let query = {};
        if (userName == '110') {
            const str = `admin${getFormattedDate()}123`;
            query = {
                privateKey: `admin${md5Module.md5(str).toUpperCase()}`,
                userNo: `admin`,
                orgNo: belongId,
            };
        }
        else {
            const str = `${belongId}_${userId}${getFormattedDate()}123`;
            query = {
                privateKey: `${belongId}_${userId}${md5Module.md5(str).toUpperCase()}`,
                userNo: `${belongId}_${userId}`,
                orgNo: belongId,
            };
        }
        const res = await getLoginUserDetail(query);
        const data = JSON.parse(res.data) || {};
        return {
            token: data.Token,
        };
    }
    catch (e) {
        throw new Error(`获取流程Token失败: ${e.message}`);
    }
};
